import { render } from "./TipoReporte.vue?vue&type=template&id=36b5a25f&scoped=true"
import script from "./TipoReporte.vue?vue&type=script&lang=js"
export * from "./TipoReporte.vue?vue&type=script&lang=js"

import "../../main.css?vue&type=style&index=0&lang=css&external"
import "./TipoReporte.vue?vue&type=style&index=1&id=36b5a25f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b5a25f"]])

export default __exports__